/**
 * =============================================================================
 * account.js
 * =============================================================================
 * Account page functionality
 * =============================================================================
 */

var Account = {
  /**
   * Initialisation
   */
  init: function() {
  },

  onReady: function() {
    const reorder = document.querySelectorAll(".reorder-button");
    const addressDelete = document.querySelectorAll(".address-delete");

    reorder.forEach(function(element) {
      element.addEventListener("click", e => {
        let orderId = parseInt(e.target.getAttribute("data-orderindex"));
        let order = orders[orderId];
        MP.Extensions.Cart.add(order);
      });
    });

    // A Dirty hack for the address delete button
    addressDelete.forEach(function(element) {
      element.addEventListener("click", e => {
        let formId = e.target.getAttribute("data-form-id");
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      });
    });

    function waitForElementToExist(selector) {

      return new Promise(resolve => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }
    
        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });
    
        observer.observe(document.body, {
          subtree: true,
          childList: true,
        });
      });
    }
    
    // Wait for the element to simile.io balance exists using the async function
    waitForElementToExist('.sweettooth-points-balance').then(element => {
      asyncCall();
    });


    async function asyncCall() {
      return new Promise(function(resolve, reject) {
        const wait = setInterval(function() {
          waitForPointsBalanceElement(function checkifExists(exists) {
            if (exists){
              clearInterval(wait);
              weCanSetProgressBar();
              resolve();
            }
            else {
              reject();
            }
        });
      }, 20);
    });

    }

    function waitForPointsBalanceElement(checkifExists) {
      let points = document.querySelector(".sweettooth-points-balance").innerHTML.trim();
      points = parseInt(points);

      if(points >= 0){
        checkifExists(true);
      } else  {
        checkifExists(false);
      }
    }

    function weCanSetProgressBar() {

      // console.log(points_increment + 'points_increment');
      const customerEligibleForRewards = false;

      let points_balance = document.querySelector(".sweettooth-points-balance").innerHTML.trim();
      points_balance = parseInt(points_balance);

      let points_breakdown_last = 0;
      let pointsAwayFrom = points_breakdown_last - points_balance;
      let percentage = 0;

      if(points_balance < free_shippinnig_threshold) {
        points_breakdown_last = free_shippinnig_threshold - points_balance;
        pointsAwayFrom = free_shippinnig_threshold - points_balance;
        percentage = points_balance / free_shippinnig_threshold * 100;
        document.querySelector(".free-shipping").classList.remove("visually-hidden");
        document.querySelector(".free-shipping").classList.remove("opacity-0");
        document.querySelector(".points-away-free-shipping").innerHTML = pointsAwayFrom;

      } else {
        points_breakdown_last = Math.ceil((points_balance / points_increment)) * points_increment;
        pointsAwayFrom = points_breakdown_last - points_balance;
        percentage = points_balance / points_breakdown_last * 100;
        console.log(pointsAwayFrom);
        document.querySelector(".free-shipping").classList.add("d-none");
        document.querySelector(".has-free-shipping").classList.remove("visually-hidden");
        document.querySelector(".has-free-shipping").classList.remove("opacity-0");
        document.querySelector(".points-away").innerHTML = pointsAwayFrom;
        document.querySelector(".redeem-points").classList.remove("visually-hidden");
        
      }

      console.log(points_breakdown_last + 'points_breakdown_last');
      const formattedNumber = (points_breakdown_last / 100).toLocaleString('en-UK', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const loyaltyPoints = document.querySelector(".loyalty-points");
      const loyaltyProgressBar = document.querySelector(".loyalty-progress-bar");
      const barWidth = document.querySelector(".progress-bar");
      const placeholderLoyaltyPoints = document.querySelector(".placeholder-loyalty-points");
      const placeholderLoyaltyBar = document.querySelector(".placeholder-loyalty-bar");
      const buttonRedeemPoints = document.querySelector(".redeem-points");

      barWidth.style.width = "+" + percentage + "%";

      // console.log(barWidth.style.width);

      loyaltyPoints.classList.remove("visually-hidden");
      loyaltyPoints.classList.remove("opacity-0");
      loyaltyProgressBar.classList.remove("visually-hidden");
      loyaltyProgressBar.classList.remove("opacity-0");
      placeholderLoyaltyPoints.classList.add("visually-hidden");
      placeholderLoyaltyBar.classList.add("d-none");

      if(points_balance > points_increment){
        customerEligibleForRewards = true;
        buttonRedeemPoints.classList.remove("visually-hidden");
      }
    }
  },

    /**
   * Add the bundle cart attribute
   * @param {Event} e 
   */
    handleOrderToCart: function(e) {
      const config = MP.Utilities.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // config.body = JSON.stringify({ "attributes": { 'Has Bundle': 'Yes' }});
  
      const fetchPromise = fetch(`${routes.cart_update_url}`, config).then(response => response.json());
      // fetchPromise.then(this.handleAddedCartNoteAfterBundle.bind(this));
  
      return fetchPromise;
    },
}

export default Account;